var availCheckMixin = {
	data: {
		rooms: [{adults: 2, children: 0}],
		disabledButton: false,
		calendars: {},
        occupancyPanelVisible: false,
        occupancyFieldActive: false,
        occupancyPanelClick: false,
        hyperFocus: 0,
        watchRooms: false
	},
    watch: {
        rooms: {
            deep: true,
            handler: function(val, oldval) {
                if (this.watchRooms) {
                    this.changeForm();
                }
            }
        }
    },
	computed: {
		getTableRows: function() {
			var tableRows = [];
			for (var room = 0; room < this.rooms.length; room++) {
				tableRows.push({
					type: 'room',
					room: room,
				});
				for (var child = 0; child < this.rooms[room].children; child++) {
					tableRows.push({
						type: 'childAge',
						child: child,
						room: room,
					});
				}
			}
			return tableRows;
		},
		errorMessageClass: function() {
        	if (!this.sharedState.errorType) return;
        	return this.sharedState.errorType.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
        },
        errorMessage: function() {
        	if (!this.sharedState.errorType || !this.i18n.errors[this.sharedState.errorType]) return 'Sorry, an error occurred';
			var message = this.i18n.errors[this.sharedState.errorType];
			if (this.sharedState.errorType == 'soldOut') {
				message = message.replace('%0%', '').replace('%1%', '<a href="#alternative-hotels">').replace('%2%', '</a>');
			}
        	return message;
        }
	},
	mounted: function() {
		this.calendars = win.calendar.addCalendars(this.$el.querySelector('.checkin-text'),
		 	this.$el.querySelector('.checkout-text'), { sync: true });
        if (['bookTonight', 'bookTomorrow'].indexOf(this.sharedState.siteLink) != -1) {
            win.store.set('startSelect', win.calendar.getYMD(this.sharedState.siteLink == 'bookTonight' ? win.calendar.today() : win.calendar.tomorrow())); 
            win.store.set('endSelect', win.calendar.getYMD(this.sharedState.siteLink == 'bookTonight' ? win.calendar.tomorrow() : win.calendar.dayAfterTomorrow()));
            this.storeQueryObj();
        } 
		this.initAvailCheck();
        this.$nextTick(function() {
            this.watchRooms = true;
        });
	},
	methods: {
        changeForm: function() { // placeholder
        },
        initAvailCheck: function() {
			this.rooms = $url.decodeRmcnf(this.sharedState.query.rmcnf) || [{adults: 2, children: 0}];
			win.calendar.setSyncedCalendars();
        },
        getTravellersBtnTxt: function() {
            var adults = 0, children = 0;
            for (var room = 0; room < this.rooms.length; room++) {
                adults += parseInt(this.rooms[room].adults);
                children += parseInt(this.rooms[room].children);
            }
            var btnTxt = [];
            btnTxt.push(adults+" "+this.i18n.adult[adults == 1 ? 0 : 1]);
            if (children) {
                btnTxt.push(children+" "+this.i18n.child[children == 1 ? 0 : 1]);
            }
            btnTxt.push(this.rooms.length+" "+ this.i18n.room[this.rooms.length == 1 ? 0 : 1]);
            return btnTxt.join(', ');
        },
        toggleOccupancyPanel: function() {
            if (!this.occupancyPanelVisible) {
                this.occupancyPanelVisible = true;
                this.toggleHyperFocus(true);
                this.scrollToPanel();
                this.occupancyFieldActive = true;
            } else {
                this.closeOccupancyPanel();
            }
        },
        closeOccupancyPanel: function() {
            if (this.occupancyPanelVisible) {
                this.occupancyPanelVisible = false;
                this.toggleHyperFocus(false);
                this.occupancyFieldActive = false;
                this.$refs['occupancy-btn'].blur();
            }
        },
        occupancyPanelMouseDwn: function(event) {
            if (event.target.tagName != 'SELECT') {
                event.preventDefault();
                // this.$refs['occupancy-btn'].focus();
            } else {
                this.occupancyPanelClick = true;
            }
        },
        occupancyBtnBlur: function() {
            if (!$d.parents(document.activeElement, '.occupancy-panel') && !this.occupancyPanelClick) {
                this.closeOccupancyPanel(); 
            }
            this.occupancyPanelClick = false;
        },
        childAgeSelectBlur: function(event) {
            var $isRemovedCheck = event.target;
            window.setTimeout(function(caller) { return function() {
                if (!$d.parents(document.activeElement, '.occupancy-panel') && document.activeElement != caller.$refs['occupancy-btn'] && $d.parents($isRemovedCheck, 'body')) {
                    caller.closeOccupancyPanel();
                }
            };}(this), 50);
        },
        scrollToPanel: function() {
            var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
                delay = (win.isMobile) ? 350 : 50,
                margin = 10,
                $panel = this.$refs['occupancy-panel'],
                $btn = this.$refs['occupancy-btn'],
                $fixedHeader = gE('header-hotel-fixed'),
                fixedHeader = !win.isMobile && $fixedHeader ? $fixedHeader.offsetHeight || 65 : 0;
            window.setTimeout( function() {
                var btnTopPos = $btn.getBoundingClientRect().top - margin - fixedHeader;
                var panelBottomPos = windowHeight - ($panel.getBoundingClientRect().bottom + margin);
                if (panelBottomPos < 0) {
                    if (btnTopPos > -panelBottomPos) {
                        $d.scrollto({distance: -panelBottomPos });
                    } else {
                        $d.scrollto({distance: btnTopPos });
                    }
                }
            }, delay);
        },
        addRoom: function(event) {
            if (this.rooms.length < 8) {
                this.rooms.push({adults: 2, children: 0});
            } else {
                location.href = win.externalUrl.groupBooking;                
            }
        },
        removeRoom: function() {
            if (this.rooms.length > 1) {
                this.rooms.pop();
            }
        },
        addAdult: function(room) {
            if (this.rooms[room].adults < 6) {
                this.rooms[room].adults++;
            }
        },
        removeAdult: function(room) {
            if (this.rooms[room].adults > 1) {
                this.rooms[room].adults--;            
            }
        },
        addChild: function(room) {
            if (this.rooms[room].children < 6) {
                this.rooms[room].children++;
                if (!this.rooms[room].childAges) {
                    this.rooms[room].childAges = [0];
                } else {
                    this.rooms[room].childAges.push(0);
                }
            }
        },
        removeChild: function(room) {
            if (this.rooms[room].children > 0) {
                this.rooms[room].children--;
                this.rooms[room].childAges.pop();
            }
        },
        changeChildAge: function(room, child, event) {
            this.rooms[room].childAges[child] = event.target.value;
        },

        clickErrorMessage: function() {
        	// only relevant for hotel detail page
        },
        submit: function(event) {
        	if (event) {
                event.preventDefault();
        	    this.startBtnLoader(event.target);
            }
            this.storeQueryObj({
        		success: function(query) {
                    // go to search results by default. submit() is redefined where needed.
    		        document.location.href = $url.encodeVar({ q: $url.encodeQ(this.sharedState.query)}, 
                        { url: win.internalUrl.search });	
        		},
                failed: function(errorType) {
                    if (event) this.stopBtnLoader(event.target);
                    win.store.set('errorType', errorType);
                }
        	});
        },
        storeQueryObj: function(config) {
            config = config || {};

            var validateSearchField = function(str) {
                    return str.replace(/\s+/g,' ').trim().length >= 3;
                },
                $form = this.$refs['search-form'] || this.$parent.$refs['search-form'];

            if (!$form) return;

            // get the q value (copy):
            var objQ = JSON.parse(JSON.stringify(this.sharedState.query));
            var i;

            // get the searched value:
            
            if (this.sharedState.dstTypeSelect) objQ.dstt = this.sharedState.dstTypeSelect;
            if (this.sharedState.dstIdSelect) objQ.dsti = this.sharedState.dstIdSelect;
            if (this.sharedState.dstStringSelect) objQ.dsts = this.sharedState.dstStringSelect;
            if (this.sharedState.sort) objQ.sort = this.sharedState.sort;

            var errorType = null;

            if ($form.querySelector('[name="destination"]') && !validateSearchField(this.sharedState.dstStringSelect)) {
                errorType = 'noSearch';
            }

            // get the dates:
            objQ.start = this.sharedState.startSelect;
            objQ.end = this.sharedState.endSelect;
            
            // get the currency
            if (!objQ.cur) objQ.cur = this.sharedState.currency;

            // get the facilities and property type values:
            var fac = 0,
                typ = 0,
                hasFac = false,
                hasTyp = false;
            for (var id in this.$refs) {
                if (id.indexOf('fac_') === 0) {
                    fac += this.$refs[id].checked ? parseInt(id.replace('fac_', '')) : 0;
                    hasFac = true;
                } else if (id.indexOf('typ_') === 0) {
                    typ += this.$refs[id].checked ? parseInt(id.replace('typ_', '')) : 0;
                    hasTyp = true;
                }
            }

            // only update facilities/property type if form contains them
            if(hasFac) objQ.fac = fac;
            if(hasTyp)  objQ.typ = typ;
            
            // get the stars values:
            var arrStars = [], $star;
            for(i=1; i<=5; i++) {
                $star = gE('star_'+i);
                if($star && $star.checked) {
                    arrStars.push(i);
                }
            }
            // only update stars if form contains them
            if ($star) {
                objQ.stars = arrStars.join(',');        
            }
            
            // get the radius if set
            if(this.searchRadius != undefined && this.searchRadius > 0){
                objQ.rad = this.searchRadius;
            } else {
                objQ.rad = 0;
            }

            if(this.offset != undefined){
                objQ.offset = this.offset;
            }
            /**
             * Check if people search with availability
             */

            if(objQ.wa == 0 && (objQ.end == '' || objQ.start == '')) {
                errorType = 'noDates';
            } else if (objQ.wa == 0 && objQ.end && objQ.start) {
                var result = win.calendar.validateDates(objQ.start, objQ.end);
                if (!result.valid) {
                    errorType = result.errorType;
                }
            } 
            
            
        //  /**
        //   * Check if dates are legally allowed, only needed when searching with availability
        //   */ 
            if (errorType) {
                if (config.failed) config.failed.call(this, errorType);
                return;
            } 

            if (this.rooms) {
                objQ.rmcnf = $url.encodeRmcnf(this.rooms);      
            }
            objQ.sf   = "1";

            if (!config.validateOnly) {

                $cookie.updatePrsCookie({q: $url.encodeQ(objQ)});
                win.store.set('query', objQ);

            }
            
            if (config.success) config.success.call(this, objQ);
            
            return objQ;
        },

        toggleHyperFocus: function(show) {
            var $panel = document.getElementById('hyper-focus');
            this.hyperFocus = this.hyperFocus + (show ? 1 : -1);
            if (this.hyperFocus < 0) this.hyperFocus = 0;
            if (this.hyperFocus) {
                $panel.classList.add('visible');
            } else {
                window.setTimeout(function(caller) { return function() { 
                    if (!caller.hyperFocus) $panel.classList.remove('visible');
                };}(this), 100);
            }
        }

    }
};
